import { Component } from 'react';

import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkSmallChevronDownIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-down';
import BpkSectionList, {
  BpkSectionListSection,
  BpkSectionListItem,
} from '@skyscanner-internal/backpack-web/bpk-component-section-list';
import BpkText from '@skyscanner-internal/backpack-web/bpk-component-text';

import type { UrlsAndLabelItem } from '@skyscanner-internal/landing-pages-shared-types/types-shared/RelevantRoutesLinksProps';
import type { RelevantRoutesLinksProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './RelevantRoutesLinks.module.scss';

interface RelevantRoutesLinksState {
  sectionClass: string;
  buttonClass: string;
}

const HIDDEN_STATE = {
  sectionClass: `${STYLES.RelevantRoutesLinks__hide} ${STYLES.RelevantRoutesLinks__section}`,
  buttonClass: String(STYLES.RelevantRoutesLinks__button),
};

const NO_SHOW_STATE = {
  sectionClass: String(STYLES.RelevantRoutesLinks__section),
  buttonClass: `${STYLES.RelevantRoutesLinks__button} ${STYLES.RelevantRoutesLinks__buttonNoshow}`,
};

const MIN_ITEMS_TO_TRUNCATE = 6;

const getShowAllState = (unrestrictedHeigh: boolean) => ({
  sectionClass: unrestrictedHeigh
    ? String(STYLES.RelevantRoutesLinks__section__fullHeight)
    : String(STYLES.RelevantRoutesLinks__section),
  buttonClass: unrestrictedHeigh
    ? `${STYLES.RelevantRoutesLinks__button_fullHeight} ${STYLES.RelevantRoutesLinks__buttonHidden}`
    : `${STYLES.RelevantRoutesLinks__button} ${STYLES.RelevantRoutesLinks__buttonHidden}`,
});

class RelevantRoutesLinks extends Component<
  RelevantRoutesLinksProps,
  RelevantRoutesLinksState
> {
  constructor(props: RelevantRoutesLinksProps) {
    super(props);

    this.state =
      props.urlsAndLabels.length > MIN_ITEMS_TO_TRUNCATE
        ? HIDDEN_STATE
        : NO_SHOW_STATE;
  }

  showAll() {
    const unrestrictedHeight = this.props.unrestrictedHeight ?? false;
    this.setState(getShowAllState(unrestrictedHeight));
  }

  render() {
    const { strings, urlsAndLabels } = this.props;

    return (
      <div id="relevant-routes-links-root">
        <BpkSectionList className={STYLES.RelevantRoutesLinks}>
          <BpkText
            tagName="h2"
            textStyle="heading-2"
            className={STYLES.RelevantRoutesLinks__header}
          >
            {strings.flights_routes_from_to_title}
          </BpkText>
          <BpkSectionListSection className={this.state.sectionClass}>
            {urlsAndLabels.map((link: UrlsAndLabelItem) => (
              <BpkSectionListItem
                className={STYLES.RelevantRoutesLinks__ulist}
                key={link.url}
                href={link.url}
              >
                {link.label}
              </BpkSectionListItem>
            ))}
            <BpkButton
              className={this.state.buttonClass}
              onClick={() => this.showAll()}
              type={BUTTON_TYPES.secondary}
            >
              {strings.flights_routes_from_show_all}
              <BpkSmallChevronDownIcon
                className={STYLES.RelevantRoutesLinks__chevronDown}
              />
            </BpkButton>
          </BpkSectionListSection>
        </BpkSectionList>
      </div>
    );
  }
}

export default RelevantRoutesLinks;
